export const generateUrl = (href: string, currency?: string) => {
  const url = new URL(href)
  if (currency) {
    url.searchParams.set('currency', currency)
  }
  return url.href
}
